/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// import Vue from "vue";
import router from "./router.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import store from "./store.js";
import bootstrap from "./bootstrap";

window.Vue = require("vue").default;

// require("./bootstrap");
Vue.use(bootstrap);
Vue.use(VueSweetalert2);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context("./", true, /\.vue$/i);
files
  .keys()
  .map((key) =>
    Vue.component(key.split("/").pop().split(".")[0], files(key).default)
  );

// Vue.component('login', require('./components/LoginComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

let app;

let setupTokenForAxios = () => {
  let token = document.head.querySelector('meta[name="csrf-token"]');

  if (token) {
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
  } else {
    console.error(
      "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
    );
  }
};
let initVue = () => {
  return new Vue({
    el: "#vue-app",
    router,
    store,
  });
};

let documentReadyFunc = () => {
  setupTokenForAxios();
  app = initVue();
};

if (process.env.NODE_ENV === 'production') {
  console.log = function () { };
}

documentReadyFunc();
